import { Component, Vue } from 'vue-property-decorator';

const AdInputBooleanProps = Vue.extend({
  props: {
    checkbox: Boolean,
    disabled: Boolean,
    fieldMeta: Object,
    value: Boolean,
  },
});

@Component
export default class AdInputBoolean extends AdInputBooleanProps {
  /**
   * For checkbox type, indicates whether it's checked or not.
   */
  checked: boolean = false;

  /**
   * For dropdown list, indicates whether it's selected or not.
   */
  selected: boolean = false;

  /**
   * Dropdown list only needs yes & no options.
   */
  options: any[] = [
    {
      id: 'Y',
      label: 'Yes',
      value: true,
    },
    {
      id: 'N',
      label: 'No',
      value: false,
    },
  ];

  onSelectChanged(value?: boolean) {
    this.$emit('input', value);
  }

  onCheckboxChanged(value: boolean) {
    this.$emit('input', value);
  }
}
